import * as React from 'react';
import { connect } from 'react-redux'

import { getActiveChannelId } from '../reducers/gui'
import { isQuickBetsActive }from '../reducers/gui'
import { getTimings, getMatchIds } from '../reducers/timings'

import MatchListOddsPresentation  from '../presentations/MatchListOdds/MatchListOddsPresentation';

const mapStateToProps = ( state: any ) => {
    return ({
        timings: getTimings(state),
        activeChannelId: getActiveChannelId(state),
        quickBetsState: isQuickBetsActive(state)
    });
}

export default connect( mapStateToProps )( MatchListOddsPresentation )
